<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="closeDialog">
        <div>
        <div class="banner"
            :style="{'background': '#0F5EFF url(' + baseUrl + content.topBigImage + ')','background-repeat':'no-repeat','background-size':'cover'}">
            <div class="top">
            <div>
                <div class="topTitle">{{content.topTitle}}</div>
                <div class="topContent">{{content.topContent}}</div>
            </div>
            <div class="topSmallImage">
                <img :src="baseUrl + content.topSmallImage" alt="">
            </div>
            </div>
        </div>
        </div>
        <div class="solution">
        <div class="solutionContent">
            <div style="display: flex;align-items: center;margin: 15px 0;">
              <span class="fa">解决方案</span>
              <span class="forLibne"></span>
              <span class="program">PROGRAM</span>
            </div>
            <div class="contentFire">{{content.solutionText}}</div>
            <div class="solutionImage" v-if="content.solutionImage">
              <img :src="baseUrl + content.solutionImage">
            </div>
        </div>
    </div>
    <div class="highlights">
        <div class="highlightsContent"  v-if="content.solutionHighImage">
            <div style="display: flex;align-items: center;margin: 15px 0;">
              <span class="fa">方案亮点</span>
              <span class="forLibne"></span>
              <span class="program">PROGRAM</span>
            </div>
            <div class="highlightsImage">
              <img :src="baseUrl + content.solutionHighImage">
            </div>
        </div>
    </div>
        <div class="value" v-if="content.solutionValue">
            <div class="valueContent">
                <div style="display: flex;align-items: center;margin: 15px 0;">
                <span class="fa">方案价值</span>
                <span class="forLibne"></span>
                <span class="program">VALUE</span>
                </div>
                <div class="contentFire">{{content.solutionValue}}</div>
            </div>
        </div>
        <div class="case" v-if="content.solutionAppImage">
            <div class="caseContent">
                <div style="display: flex;align-items: center;margin: 15px 0;">
                <span class="fa">应用案例</span>
                <span class="forLibne"></span>
                <span class="program">APPLICATIONS</span>
                </div>
                <div class="caseImage">
                <img :src="baseUrl + content.solutionAppImage">
                </div>
            </div>
        </div>

        <div class="downBox" v-if="content.fileUrl">
          <a class="downBtn" @click="downFile(content.fileUrl)"><img class="upIcon" src="../../../assets/images/uploadIcon3@2x.png" />附件下载</a>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {
    solutionById
  } from '@/api/api'
import {
    serverUrl
  } from '@/utils/server.js'
export default {
  data() {
    return {
      title:'查看方案',
      dialogVisible: false,
      content:{},
      baseUrl: serverUrl.baseURL
    }
  },
  methods: {
      openDialog(id) {
          this.dialogVisible = true
          if(id) {
            this.getSolutionById(id)
          }
      },
      closeDialog() {
          this.dialogVisible = false
      },
      getSolutionById(id) {
        solutionById({
          id: id
        }).then(res => {
          this.content = res.data
        })
      },
      downFile(url) {
        if (!url) return
        let filename = url.substring(url.lastIndexOf('/')+1)
        let link = document.createElement('a') //创建a标签
        link.style.display = 'none'  //使其隐藏
        link.href = this.baseUrl + url //赋予文件下载地址
        link.setAttribute('download',filename) //设置下载属性 以及文件名
        document.body.appendChild(link) //a标签插至页面中
        link.click() //强制触发a标签事件
        document.body.removeChild(link);
      },
  }
}
</script>
<style scoped>
.banner {
    width: 100%;
    height: 300px;
    display: flex;
    align-items: center;
    color: #fff;
    box-sizing: border-box;
    padding: 0 10px;
  }

  .top {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .topTitle {
    font-size: 24px;
    line-height: 70px;
    font-weight: 700;
  }

  .topSmallImage img{
    width: 150px;
  }

  .topContent {
    font-size: 16px;
    line-height: 35px;
  }

  .solution, .highlights, .case, .value {
    width: 100%;
    margin: 60px 0;
  }

  .solutionContent, .highlightsContent, .caseContent, .valueContent {
    /* width: 1189px; */
    margin: 0 auto;
    /* border: 1px solid red; */
  }

  .fa {
        font-size: 22px;
        font-weight: 700;
  }

  .program {
    color: #173381;
        font-size: 22px;
        font-weight: 700;
  }

  .forLibne {
    display: inline-block;
        width: 2px;
        height: 22px;
        background-color: #232323;
        margin: 0 15px;
  }

  .contentFire {
    font-size: 16px;
        line-height: 30px;
        text-indent: 2em;
        height: auto;
        width: 100%;
        color: #000;
  }

  .solutionImage {
    margin: 10px;
  }

  .solutionImage img {
    width: 90%;
    margin: 0 auto;
  }

  .highlightsImage, .solutionImage, .caseImage {
    text-align: center;
  }
  .caseImage img {
    width: 100%;
  }
  
  .highlightsImage img{ 
    width: 90%;
    margin: 0 auto;
  }
  .downBox{
   margin: 0 auto;
  }
  .downBtn{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    padding: 15px 0px;
    background: rgba(0, 0, 255, 1);
    cursor: pointer;
    display: block;
    width: 100%;
    text-align: center;
    border-radius: 12px;
  }
  .downBtn .upIcon{
    width: 16px;
    vertical-align: middle;
    margin-right: 10px;;
  }
</style>



// WEBPACK FOOTER //
// src/views/console/components/SolveDetailDialog.vue